<template>
  <div class="chat_message_box">
    <div
      v-if="unreadNum"
      class="message_tip message_tip_up"
      @click="getHistoryMessage1(lastReadTime)"
    >
      <img src="@/assets/img/circleV2/icon_arrow_up.png" alt="" />
      {{ unreadNum }}条新消息
    </div>
    <VirtualScrollbar ref="virtualScrollbar">
      <TouchTheBottom
        v-if="initStatus && messageList.length"
        ref="touchTheBottom"
        :id-name="id"
        @getMore="getHistoryMessage"
      />
      <div v-if="messageList.length" ref="allMessageDom" class="message_cells">
        <div
          v-for="(item, index) in messageList"
          :key="index"
          class="message_cell"
        >
          <ChatMessageCell
            :user-info="userInfo"
            :info="item"
            :id="id"
            :circle_id="circle_id"
            :use-svip-list="useSvipList"
            @retrySend="retrySend"
            @deleteMessage="delConfirmApi"
          />
        </div>
      </div>
      <Nodata v-else height="100%" />
    </VirtualScrollbar>
    <div
      v-if="unreadNewNum"
      class="message_tip message_tip_down"
      @click="viewNewMessage"
    >
      <img src="@/assets/img/circleV2/icon_arrow_down.png" alt="" />
      {{ unreadNewNum }}条新消息
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Debounce } from "@/utils/debounce";
import ChatMessageCell from "@/components/circleV2/ChatMessageCell.vue";
export default {
  components: {
    ChatMessageCell,
  },
  props: {
    id: {
      type: String,
      default: String,
    },
    userInfo: {
      type: Object,
      default: Object,
    },
    useSvipList: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      circle_id: null,
      teacher_id: null,
      symbol: "",
      createtime: "",
      type: null, // 1圈友互动2我的消息3老师发布的品种消息
      messageList: [],
      initStatus: false,
      unreadNum: 0,
      lastReadTime: 0,
      unreadNewNum: 0,
    };
  },
  mounted() {
    setTimeout(() => {
      this.$refs.virtualScrollbar.isBottom();
    }, 1000 * 3);
  },
  methods: {
    init(obj) {
      this.initStatus = false;
      this.circle_id = obj.circle_id;
      this.teacher_id = obj.teacher_id;
      this.symbol = obj.symbol;
      this.createtime = obj.createtime;
      this.type = obj.type;
      this.getCircleChatList();
    },
    // 获取最新的消息
    async getCircleChatList() {
      const res = await request.post("/teacher/circle/getCircleChatList", {
        circle_id: this.circle_id,
        teacher_id: this.teacher_id,
        symbol: this.symbol,
        createtime: this.createtime,
        type: this.type,
      });
      const list = res.data.list;
      const messageList = [];
      for (const item of list) {
        messageList.unshift(item);
      }
      this.messageList = messageList;
      this.unreadNum = res.data.unread_num;
      this.lastReadTime = res.data.last_read_time;
      // 恢复本地未发送消息（切换聊天后列表被服务端数据替换，本地消息会丢失）
      this.restorePendingMessages();
      if (list.length) {
        this.scrollToBottom();
      }
      this.updateVirtualScrollbar();
      setTimeout(() => {
        this.initStatus = true;
        setTimeout(() => {
          this.$refs.touchTheBottom &&
            this.$refs.touchTheBottom.updateLoading(list.length ? 1 : 3);
        });
        this.readChat();
      }, 1000);
    },
    // 恢复本地未发送消息（切换聊天后列表被服务端数据替换时调用）
    restorePendingMessages() {
      const queueMessage = this.$parent.queueMessage;
      if (!queueMessage || !queueMessage.size) return;
      const type = this.type;
      for (const [, qItem] of queueMessage) {
        // 按列表类型过滤：有symbol的消息在teacherChatList，无symbol的在normalChatList
        if (type === 3 && !qItem.symbol) continue;
        if (type !== 3 && qItem.symbol) continue;
        // 检查是否已在当前列表中（避免重复添加）
        const exists = this.messageList.some((m) => m.msg_id === qItem.msg_id);
        if (!exists) {
          this.messageList.push(qItem);
        }
      }
    },
    // 获取历史消息
    async getHistoryMessage() {
      const messageList = this.messageList;
      const res = await request.post("/teacher/circle/getCircleChatList", {
        circle_id: this.circle_id,
        teacher_id: this.teacher_id,
        symbol: this.symbol,
        createtime: messageList[0].createtime,
        type: this.type,
      });
      const oldScrollHeight = this.$refs.allMessageDom.scrollHeight;
      const list = res.data.list;
      for (const item of list) {
        messageList.unshift(item);
      }
      setTimeout(() => {
        const newScrollHeight = this.$refs.allMessageDom.scrollHeight;
        this.$refs.virtualScrollbar.setScrollTopVal(
          newScrollHeight - oldScrollHeight
        );
      });
      if (messageList.length) {
        this.updateVirtualScrollbar();
      }
      this.$refs.touchTheBottom.updateLoading(list.length ? 1 : 3);
    },
    getHistoryMessage1: Debounce(async function (e) {
      const messageList = this.messageList;
      const res = await request.post("/teacher/circle/getCircleChatList", {
        circle_id: this.circle_id,
        teacher_id: this.teacher_id,
        symbol: this.symbol,
        createtime: e,
        type: this.type,
        limit: this.unreadNum,
        up_log: 1,
      });
      const list = res.data.list;
      for (const item of list) {
        if (
          !messageList.filter((i) => i.createtime === item.createtime).length
        ) {
          messageList.unshift(item);
        }
      }
      setTimeout(() => {
        this.$refs.virtualScrollbar.setScrollTopVal(0);
      });
      if (messageList.length) {
        this.updateVirtualScrollbar();
      }
      this.$refs.touchTheBottom.updateLoading(list.length ? 1 : 3);
      this.unreadNum = 0;
    }),
    async readChat() {
      await request.post("/api/circle/readChat", {
        circle_id: this.circle_id,
        type: this.type,
      });
    },
    scrollToBottom() {
      setTimeout(() => {
        const domHeight = this.$refs.allMessageDom.offsetHeight;
        this.$refs.virtualScrollbar.setScrollTopVal(domHeight);
        this.unreadNewNum = 0;
      }, 500);
    },
    viewNewMessage: Debounce(function () {
      this.scrollToBottom();
    }),
    updateVirtualScrollbar() {
      setTimeout(() => {
        this.$refs.virtualScrollbar.update();
      }, 500);
    },
    updateNewMessage(data) {
      const isBottom = this.$refs.virtualScrollbar.isBottom();
      const messageList = this.messageList;
      const type = this.type;
      const userInfo = this.userInfo;
      const messageInfo = {
        content: data.content,
        createtime: data.createtime,
        createtime_text: data.createtime_text,
        images: data.images,
        id: data.chat_id,
        question: data.question,
        message_type: data.message_type || "text",
        reply_content: data.reply_content,
        reply_images: data.reply_images,
        reply_id: data.reply_id,
        reply_question: data.reply_question,
        reply_user_id: data.reply_user_id,
        reply_user_nickname: data.reply_user_nickname,
        symbol: data.symbol,
        symbol_name: data.symbol_name,
        teacher_id: data.teacher_id,
        to_user_id: data.to_user_id,
        user: {
          avatar: data.user_info.avatar,
          id: data.user_info.id,
          is_teacher: data.user_info.is_teacher,
          mobile: data.user_info.mobile,
          nickname: data.user_info.nickname,
        },
        user_id: data.user_id,
        local: 0,
        msg_id: data.msg_id,
        is_shanghai_msg: data.is_shanghai_msg,
        only_my_look: data.only_my_look,
        join_day: data.join_day,
        join_user_id: data.join_user_id,
        join_user_info: data.join_user_info,
      };
      // 如果存在本地待确认消息（msg_id匹配），用服务端数据替换，清除loading状态
      if (data.msg_id) {
        const existIdx = messageList.findIndex((m) => m.msg_id === data.msg_id);
        if (existIdx > -1) {
          Object.assign(messageList[existIdx], messageInfo);
          if (data.user_id * 1 === userInfo.id * 1) {
            this.scrollToBottom();
          }
          this.updateVirtualScrollbar();
          return;
        }
      }
      // 用本地匹配键去重（服务端回显不含msg_id时的兜底匹配，分钟精度）
      // 遍历父组件queueMessage精确匹配：时间和内容一致的待确认消息即为同一消息
      const queueMessage = this.$parent.queueMessage;
      if (queueMessage && data.createtime_text && data.user_id) {
        const minuteText = data.createtime_text.substring(0, 16);
        for (const [msgId] of queueMessage) {
          const existIdx = messageList.findIndex(
            (m) => m.msg_id === msgId && m.local === 1
          );
          if (existIdx > -1) {
            const local = messageList[existIdx];
            if (
              local.createtime_text &&
              local.createtime_text.substring(0, 16) === minuteText &&
              String(local.user_id) === String(data.user_id) &&
              (local.content || "") === (data.content || "")
            ) {
              Object.assign(messageList[existIdx], messageInfo, {
                _localKey: local._localKey,
              });
              if (data.user_id * 1 === userInfo.id * 1) {
                this.scrollToBottom();
              }
              this.updateVirtualScrollbar();
              return;
            }
          }
        }
      }
      // 圈友互动
      if (type === 1) {
        // 不显示品种相关、不显示提问、不显示回答
        if (!data.symbol && !data.question && !data.reply_question) {
          messageList.push(messageInfo);
          // 如果不是则检测滚动条是否在底部，即判断用户是否在查看历史消息
          if (!isBottom && data.user_id * 1 !== userInfo.id * 1) {
            this.unreadNewNum++;
          } else {
            this.scrollToBottom();
          }
        }
      }
      // 我的消息
      if (type === 2) {
        // 我发送的所有消息、回复我的所有消息（排除品种消息）
        if (
          !data.symbol &&
          (data.user_id * 1 === userInfo.id * 1 ||
            data.reply_user_id * 1 === userInfo.id * 1)
        ) {
          messageList.push(messageInfo);
          // 如果不是则检测滚动条是否在底部，即判断用户是否在查看历史消息
          if (!isBottom && data.user_id * 1 !== userInfo.id * 1) {
            this.unreadNewNum++;
          } else {
            this.scrollToBottom();
          }
        }
        // 检测是否开启消息提醒
        if (
          data.user_id * 1 !== userInfo.id * 1 &&
          data.reply_user_id * 1 === userInfo.id * 1
        ) {
          this.sendMessageTip(data);
        }
      }
      // 老师发布的品种消息
      if (type === 3) {
        // 老师发送并且关联了品种
        if (data.user_info.is_teacher && data.symbol) {
          // 检测是否开启消息提醒
          this.sendMessageTip(data);
          messageList.push(messageInfo);
          // 如果不是则检测滚动条是否在底部，即判断用户是否在查看历史消息
          if (!isBottom && data.user_id * 1 !== userInfo.id * 1) {
            this.unreadNewNum++;
          } else {
            this.scrollToBottom(data);
          }
        }
      }
      if (data.user_id * 1 === userInfo.id * 1) {
        // 如果是自己发的消息，则滚动到底部
        this.scrollToBottom();
      }
      this.updateVirtualScrollbar();
    },
    messageListPush(e) {
      const isBottom = this.$refs.virtualScrollbar.isBottom();
      const messageList = this.messageList;
      const userInfo = this.userInfo;
      messageList.push(e);
      // 如果不是则检测滚动条是否在底部，即判断用户是否在查看历史消息
      if (!isBottom && e.user_id * 1 !== userInfo.id * 1) {
        this.unreadNewNum++;
      } else {
        this.scrollToBottom(e);
      }
    },
    sendMessageTip(e) {
      const { desktopNotice, soundNotice } = this.$parent.getTipValue();
      if (desktopNotice === 1) {
        console.warn("======桌面通知");
        this.$handleNotification({
          title: "V策财经 - www.i-vce.com",
          body: e.content,
          tag: e.createtime_text,
          renotify: true,
          requireInteraction: true,
          icon: require("@/assets/img/icon_logo1.png"),
        }).catch(() => {
          // this.$parent.changeNotify(0)
        });
      }
      if (soundNotice === 1) {
        console.warn("======提示音播放");
        let music = new Audio();
        music.src =
          "https://i-vce.oss-cn-shanghai.aliyuncs.com/assets/mp3/dingpan_notice.mp3";
        music.addEventListener("ended", () => {
          music = null;
        });
        music.play();
      }
    },
    handleDeleteMessage(id) {
      const messageList = this.messageList;
      for (const [index, item] of messageList.entries()) {
        if (item.id * 1 === id * 1) {
          // messageList.splice(index, 1);
          item.only_my_look = 1;
          this.updateVirtualScrollbar();
          break;
        }
      }
    },
    async delConfirmApi(id) {
      const res = await request.post("/teacher/chat/delCircleMessage", {
        uid: this.circle_id,
        id,
      });
      // 撤回后不从列表移除，只将该条消息标记为“仅自己和老师可见”
      const messageList = this.messageList;
      for (const item of messageList) {
        if (item.id == id) {
          item.only_my_look = 1;
          break;
        }
      }
      this.updateVirtualScrollbar();
      this.$message.success(res.msg);
    },
    retrySend(msgId) {
      console.log(2);
      this.$parent.queuePushSus(msgId, true);
    },
  },
};
</script>

<style scoped>
.chat_message_box {
  position: relative;
  width: 100%;
}

.message_cells {
  box-sizing: border-box;
  padding: 16px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.message_cell {
}

.message_tip {
  position: absolute;
  z-index: 1;
  right: 16px;
  height: 24px;
  box-sizing: border-box;
  padding: 0 10px;
  border-radius: 20px;
  font-weight: 400;
  font-size: 12px;
  color: #4571e7;
  display: flex;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 6px 0px;
  background-color: #fff;
  cursor: pointer;
  user-select: none;
}

.message_tip_up {
  top: 16px;
}

.message_tip_down {
  bottom: 16px;
}

.message_tip img {
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
  margin-right: 2px;
}
</style>
